var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-12"},[_c('send-file',{attrs:{"files":_vm.files,"headers":_vm.headers,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }